import React from 'react';
import classnames from 'classnames';

import {IconButton, Text} from '@albert-io/atomic';

import type {SortDir} from './useClientSort';

interface Props {
  label: string;
  sortKey: string;
  activeKey: string;
  dir: SortDir;
  onSort: (key: string) => void;
}

export const SortableHeaderCell = ({label, sortKey, activeKey, dir, onSort}: Props) => {
  const isActive = activeKey === sortKey;
  const icon = isActive && dir === 'desc' ? 'arrow-down' : 'arrow-up';
  return (
    <th
      aria-sort={isActive ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      className='px-x2 py-x1-half text-left'
    >
      <span className='gap-x0-half inline-flex items-center'>
        <Text as='span' bold>
          {label}
        </Text>
        <IconButton
          className={classnames({'opacity-40': !isActive})}
          color='secondary'
          icon={icon}
          iconStyle='regular'
          label={`Sort by ${label}`}
          onClick={() => onSort(sortKey)}
          variant='text'
        />
      </span>
    </th>
  );
};
